<template>
  <div class='app'>
    <Hero :lang='lang' @changeLang='lang = $event' :isMobile='isMobile' />
    <Bridge :lang='lang' />
    <Content :lang='lang' :dataIsReady='dataIsReady' :data='data' :resize='resize' :isMobile='isMobile' />
    <Cta :lang='lang' />
    <Footer :lang='lang' />
  </div>
</template>


<script>

import Hero from './components/Hero.vue';
import Bridge from './components/Bridge.vue';
import Content from './components/Content.vue';
import Cta from './components/Cta.vue';
import Footer from './components/Footer.vue';

import { initScrollAnimations } from './js/scrollAnimations.js';

import { json, csv } from 'd3-fetch';
import debounce from 'lodash.debounce';
import * as topojson from 'topojson-client';


export default {
  components: {
    Hero,
    Bridge,
    Content,
    Cta,
    Footer
  },
  created() {
    window.addEventListener('resize', debounce(this.handleResize, 100));
  },
  mounted() {  
    // size
    this.handleResize();

    // get the data;
    this.getData();
  
    // create the ScrollTriggers
    initScrollAnimations();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  data() {
    return {
      lang: 'en',
      data: {
        countries: [],
        villages: [],
        bridges: [],
        trips: []
      },
      dataIsReady: false,
      resize: 0,
      isMobile: false
    }
  },
  methods: {
    handleResize() {
      // set a resize flag that will always change
      this.resize = Math.random();
      
      // check for mobile
      const width = window.innerWidth;
      this.isMobile = width <= 768;

    },
    async getData() {
      await this.getCountries();
      await this.getVillages();
      await this.getBridges();
      await this.getTrips();
      await this.mergeData();
      this.dataIsReady = true;
    },
    async getCountries() {
      const uri = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';
      const jsonData = await json(uri)
      this.data.countries = topojson.feature(jsonData, jsonData.objects.countries).features;

      // drop antarctica
      this.data.countries = this.data.countries.filter(x=> {
        return x.properties.name != 'Antarctica'
      }) 
    },
    async getVillages() {
      const uri = 'https://firebasestorage.googleapis.com/v0/b/bridges-to-prosperity-viz4good.appspot.com/o/villages.csv?alt=media&token=8c9ff623-60f2-4986-955a-ef263dc22c96';
      // const uri = 'villages.csv';
      const villageData = await csv(uri, d => {
        return {
          name: d.name,
          id: +d.id,
          lat: +d.lat,
          lon: +d.lon,
          num_trips: +d.num_trips
        }
      });
      this.data.villages = villageData;
    },
    async getBridges() {
      // const uri = 'https://firebasestorage.googleapis.com/v0/b/bridges-to-prosperity-viz4good.appspot.com/o/bridges.csv?alt=media&token=77d2ed11-4f27-4870-8a7f-30359dea1346';
      const uri = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQdZq6k9BgVp8KNF-dSxu3sJRLkMGScKRxdvWs39BTx3fkkPUsXZJ-7279hsvRnvjkHvQFMiXhFPds3/pub?gid=0&single=true&output=csv'
      // const uri = 'bridges.csv';
      const bridgeData = await csv(uri, d => {
        return {
          country: d.country,
          bridge_id: d.bridge_id,
          bridge_lat: +d.bridge_lat,
          bridge_lon: +d.bridge_lon
        }
      });
      this.data.bridges = bridgeData;
    },
    async getTrips() {
      const uri = 'https://firebasestorage.googleapis.com/v0/b/bridges-to-prosperity-viz4good.appspot.com/o/trips.csv?alt=media&token=4c37cae3-2df5-45dc-a53b-551fbf9cfdd0';
      // const uri = 'trips.csv';
      const tripData = await csv(uri, d => {
        return {
          bridge_id: d.bridge_id,
          home_id: +d.home_id,
          dest_id: +d.dest_id,
          purpose: d.purpose,
        }
      })
      this.data.trips = tripData;
    },
    mergeData() {
      // merge in the lat/lon for each trip
      for (let i=0; i<this.data.trips.length; i++) {
        // get trip
        let trip = Object.assign({}, this.data.trips[i]);
        
        // merge bridge data
        try {
          const bridge_data = this.data.bridges.filter(x => { return x.bridge_id === trip.bridge_id })[0];
          trip.bridge_lon = bridge_data.bridge_lon;
          trip.bridge_lat = bridge_data.bridge_lat;
        } catch {
          console.log('bad bridge id');
        }
        
        // merge village data
        //  home
        try {
          const home_village_data = this.data.villages.filter(x => { return x.id === trip.home_id })[0];
          trip.home_lat = home_village_data.lat;
          trip.home_lon = home_village_data.lon;
        } catch {
          console.log('bad home village');
        }

        //  dest
        try {
          const dest_village_data = this.data.villages.filter(x => { return x.id === trip.dest_id })[0];
          trip.dest_lat = dest_village_data.lat;
          trip.dest_lon = dest_village_data.lon;
        } catch {
          console.log('bad dest village');
        }

        // create progress
        trip.progress = Math.random();

        // store
        this.data.trips[i] = Object.assign({}, trip);
      }
      // console.log('merged')
    }
  }
}


</script>